require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./naturstein-reinigung.json") })
        }
      }, "path---naturstein-reinigung");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---naturstein-reinigung!./.cache/json/naturstein-reinigung.json
// module id = 461
// module chunks = 231608221292675